import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { Grid, Button, TextField, Typography } from '@mui/material';

const VerifyOtp = ({ onVerifyOTP }) => {
  const navigate = useNavigate();

  // Define validation schema using yup
  const validationSchema = yup.object().shape({
    otp: yup
      .string()
      .matches(/^\d{6}$/, 'OTP must be 6 digits')
      .required('OTP is required'),
  });

  const formik = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema,
    onSubmit: (values) => {
      if (onVerifyOTP) onVerifyOTP(values.otp);
      
      // Check for stored redirect URL after successful OTP verification
      const redirectUrl = localStorage.getItem("redirectAfterLogin");
      if (redirectUrl) {
        localStorage.removeItem("redirectAfterLogin");
        navigate(redirectUrl);
      } else {
        navigate('/sample');
      }
    },
  });

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Typography variant="h5" color="textPrimary">
          OTP Verification
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Enter the One-Time Password sent to your Email-ID
        </Typography>
      </Grid>

      <Grid item>
        <form onSubmit={formik.handleSubmit}>
          <Grid container direction="column" spacing={2} alignItems="center">
            <Grid item>
              <TextField
                label="Enter OTP"
                name="otp"
                value={formik.values.otp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="outlined"
                size="small"
                inputProps={{
                  maxLength: 6,
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}
              />
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
              >
                Verify OTP
              </Button>
            </Grid>

            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Didn’t receive the code?{' '}
                <Link to="/sample" color="inherit">
                  Resend OTP
                </Link>
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body2" color="textSecondary">
                Need Help?
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default VerifyOtp;
